module.exports = __webpack_public_path__ + "img/map-05.5984ac53.jpg";